import { LabelModel } from './label.model';

export interface VariantUpdateModel {
    id: string;
    text: string;
    component_id: string;
    label_id?: number;
    is_master: boolean;
    deleted: boolean;
    variant_type: string;
}

export const AlternateTextMinHoverLength = 40;

export const ImageAlternateModalId: string = 'IMAGE_ALTERNATE_MODAL_BODY';

export interface AlternateLabelCopyPasteModel {
    alternate: string;
    label?: number;
}

export interface GroupedAlternate {
    id: string;
    master_variant_content: string;
    variant_type: string;
    alternates: {
        alternate_variant_id: string;
        content: string;
    }[];
}

export type GroupedLabels = Record<string, LabelModel[]>;

export interface ClipboardAlternate {
    alternate: string;
    label: string;
}

export interface ClipboardSection {
    type: string;
    alternate_labels: ClipboardAlternate[];
}

export interface ClipboardTransformedData {
    header: ClipboardSection[];
    body: ClipboardSection[];
}

export interface SectionTypeMasterVariant {
    id: string;
    variantType: string;
    text: string;
}

export type UpdateVariantTypeInput = {
    id: string;
    data: {
        variant_type: string;
    };
};
